/* int-l4-region-guard.js: moved from snippets/int-region-guard.liquid (pdp-html-weight lever 4 batch 2, 2026-11-02). The Liquid values arrive in the JSON island #int-rg-data. Do not edit here without the source note. */
(function () {
  'use strict';
  if (window.__intRegionGuard) return;
  var D = null;
  try { D = JSON.parse(document.getElementById('int-rg-data').textContent); } catch (e) {}
  if (!D || !D.r) return;
  var R = D.r;
  var MSG = D.msg;
  /* 2026-10-26 checkout-bounce: say what to do when a line blocks checkout, and offer the remove right there. */
  var MSG_LINE = D.line;
  var MSG_REMOVE = D.remove;
  var MSG_CHECKOUT = D.checkout;
  var BASE = 'https://intention-stock-sync.nils-8f9.workers.dev';
  var KEY = 'int-rg-v1-' + R, TTL = 15 * 60 * 1000;
  var CART_IDS = String(D.cart || '').split(',').filter(Boolean);
  var oFetch = window.fetch ? window.fetch.bind(window) : null;
  var oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
  var set = null, listP = null;

  function pageSet() { return window.INT_REGION_OOS || null; }
  function known(id) {
    id = String(id);
    var p = pageSet();
    if (p && p[id]) return true;
    return !!(set && set[id]);
  }
  function fromArr(ids) { var s = Object.create(null); for (var i = 0; i < ids.length; i++) s[String(ids[i])] = true; return s; }
  function load() {
    if (set) return Promise.resolve(set);
    if (listP) return listP;
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && c.ids && Date.now() - c.t < TTL) { set = fromArr(c.ids); return Promise.resolve(set); }
    } catch (e) {}
    if (!oFetch) return Promise.resolve(null);
    listP = new Promise(function (res) {
      var done = false;
      var timer = setTimeout(function () { if (!done) { done = true; listP = null; res(null); } }, 5000);
      oFetch(BASE + '/oos?r=' + encodeURIComponent(R), { credentials: 'omit', mode: 'cors' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (done) return; done = true; clearTimeout(timer); listP = null;
          if (!j || !j.ids) return res(null);
          set = fromArr(j.ids);
          try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), ids: j.ids })); } catch (e) {}
          res(set);
        })
        .catch(function () { if (!done) { done = true; clearTimeout(timer); listP = null; res(null); } });
    });
    return listP;
  }
  function blockedOf(ids) {
    return load().then(function () {
      var out = [];
      for (var i = 0; i < ids.length; i++) if (known(ids[i])) out.push(String(ids[i]));
      return out;
    });
  }

  function isAddUrl(u) {
    try { var p = new URL(String(u), location.href).pathname; return /\/cart\/add(\.js)?\/?$/.test(p); } catch (e) { return false; }
  }
  function idsFromPairs(get, keys) {
    var out = [];
    keys.forEach(function (k) {
      if (k === 'id' || /^items\[\d*\]\[id\]$/.test(k)) get(k).forEach(function (v) { if (v) out.push(String(v)); });
    });
    return out;
  }
  function idsFromBody(b) {
    try {
      if (!b) return [];
      if (typeof FormData !== 'undefined' && b instanceof FormData) {
        var fk = []; b.forEach(function (v, k) { if (fk.indexOf(k) < 0) fk.push(k); });
        return idsFromPairs(function (k) { return b.getAll(k); }, fk);
      }
      if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) {
        var uk = []; b.forEach(function (v, k) { if (uk.indexOf(k) < 0) uk.push(k); });
        return idsFromPairs(function (k) { return b.getAll(k); }, uk);
      }
      if (typeof b === 'string') {
        var t = b.trim();
        if (t.charAt(0) === '{') {
          var j = JSON.parse(t), out = [];
          if (j.id) out.push(String(j.id));
          if (Array.isArray(j.items)) j.items.forEach(function (it) { if (it && it.id) out.push(String(it.id)); });
          return out;
        }
        return idsFromBody(new URLSearchParams(t));
      }
    } catch (e) {}
    return [];
  }
  function blockedResponse() {
    return new Response(JSON.stringify({ status: 422, message: 'Cart Error', description: MSG }),
      { status: 422, headers: { 'Content-Type': 'application/json' } });
  }

  /* The add tap opens the drawer before the request (assets/int-cart-drawer.js). When the
     add is refused, close that empty drawer again and say why next to the form tapped. */
  var lastForm = null;
  function sayNear(form) {
    if (typeof window.__intSetCartPending === 'function') window.__intSetCartPending(false);
    if (typeof window.__intCloseCartDrawer === 'function') {
      var d = document.getElementById('drawer-cart');
      var count = d ? parseInt(d.getAttribute('data-int-cart-count') || '0', 10) : 0;
      if (!count) window.__intCloseCartDrawer();
    }
    form = form || lastForm;
    if (!form) return;
    var box = form.querySelector('[data-error-display]');
    if (box) {
      box.innerHTML = '<div class="errors"></div>';
      box.firstChild.textContent = MSG;
      box.style.display = 'block';
      box.style.height = 'auto';
      return;
    }
    var m = form.querySelector('.int-rg-msg');
    if (!m) { m = document.createElement('p'); m.className = 'int-rg-msg'; m.setAttribute('role', 'alert'); form.appendChild(m); }
    m.textContent = MSG;
  }

  /* 1. fetch */
  if (oFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && isAddUrl(url)) {
          var bodyP = init && 'body' in init ? Promise.resolve(init.body)
            : (input && typeof input.clone === 'function' ? input.clone().text() : Promise.resolve(null));
          var self = this, args = arguments;
          return bodyP.then(function (b) {
            var ids = idsFromBody(b);
            if (!ids.length) return oFetch.apply(self, args);
            return blockedOf(ids).then(function (bad) {
              if (bad.length) { sayNear(); return blockedResponse(); }
              return oFetch.apply(self, args);
            });
          });
        }
      } catch (e) {}
      return oFetch.apply(this, arguments);
    };
  }

  /* 1b. XMLHttpRequest */
  XMLHttpRequest.prototype.open = function (m, u) {
    this.__intRg = (String(m).toUpperCase() === 'POST' && isAddUrl(u));
    return oOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this, args = arguments;
    if (!xhr.__intRg) return oSend.apply(xhr, args);
    var ids = idsFromBody(body);
    if (!ids.length) return oSend.apply(xhr, args);
    blockedOf(ids).then(function (bad) {
      if (!bad.length) return oSend.apply(xhr, args);
      sayNear();
      xhr.__intRg = false;
      try { xhr.withCredentials = false; } catch (e) {}
      oOpen.call(xhr, 'GET', BASE + '/blocked?m=' + encodeURIComponent(MSG), true);
      oSend.call(xhr, null);
    });
  };

  /* 2. taps and native submits, decided at once when the list is known */
  function formIds(form) {
    var out = [];
    var els = form.querySelectorAll('[name="id"], [name^="items["][name$="[id]"]');
    for (var i = 0; i < els.length; i++) if (els[i].value) out.push(els[i].value);
    return out;
  }
  function anyKnown(ids) { for (var i = 0; i < ids.length; i++) if (known(ids[i])) return true; return false; }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('button, input[type="submit"], [role="button"]');
    var form = btn && btn.closest('form[action*="/cart/add"]');
    if (form) {
      lastForm = form;
      if (btn.matches('[data-decrease-quantity], [data-increase-quantity]')) return;
      if (anyKnown(formIds(form))) { e.preventDefault(); e.stopImmediatePropagation(); sayNear(form); }
      return;
    }
    /* 3. links: /cart/add?id= and cart permalinks /cart/<id>:<qty> */
    var a = t.closest('a[href*="/cart/"]');
    if (!a) return;
    var u; try { u = new URL(a.href, location.href); } catch (er) { return; }
    var ids = [];
    if (/\/cart\/add\/?$/.test(u.pathname)) ids = u.searchParams.getAll('id');
    else { var mm = u.pathname.match(/\/cart\/(\d+:\d+(?:,\d+:\d+)*)\/?$/); if (mm) ids = mm[1].split(',').map(function (p) { return p.split(':')[0]; }); }
    if (!ids.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    blockedOf(ids).then(function (bad) { if (!bad.length) location.href = a.href; });
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (form.matches('form[action*="/cart/add"]')) {
      lastForm = form;
      if (form.__intRgOk) { form.__intRgOk = false; return; }
      var ids = formIds(form);
      if (!ids.length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      blockedOf(ids).then(function (bad) {
        if (bad.length) { sayNear(form); return; }
        form.__intRgOk = true;
        if (form.requestSubmit) form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form);
      });
      return;
    }
    /* 4. checkout from the cart form */
    if (document.body.classList.contains('int-rg-cart-blocked') && form.querySelector('[name="checkout"]')) {
      e.preventDefault(); e.stopImmediatePropagation();
    }
  }, true);

  /* 4. the cart */
  var cartBad = CART_IDS.slice();
  function markCart() {
    var bad = Object.create(null);
    cartBad.forEach(function (id) { bad[id] = true; });
    var nodes = document.querySelectorAll('[data-remove-key]');
    for (var i = 0; i < nodes.length; i++) {
      var vid = String(nodes[i].getAttribute('data-remove-key') || '').split(':')[0];
      var line = nodes[i].closest('[data-cart-item], .cart__item, [data-line-item], li, tr') || nodes[i].parentNode;
      var on = !!bad[vid];
      line.classList.toggle('int-rg-line', on);
      var note = line.querySelector('.int-rg-line-note');
      if (on && !note) {
        note = document.createElement('span'); note.className = 'int-rg-line-note'; note.setAttribute('role', 'alert');
        note.appendChild(document.createTextNode(MSG_LINE));
        var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'int-rg-line-remove'; rm.textContent = MSG_REMOVE;
        (function (remover) { rm.addEventListener('click', function (ev) { ev.preventDefault(); remover.click(); }); })(nodes[i]);
        note.appendChild(rm);
        var host = line.querySelector('.int-cart-item__content') || line;
        host.appendChild(note);
      } else if (!on && note) note.parentNode.removeChild(note);
    }
    var blocked = cartBad.length > 0;
    document.body && document.body.classList.toggle('int-rg-cart-blocked', blocked);
    var btns = document.querySelectorAll('[name="checkout"]');
    for (var j = 0; j < btns.length; j++) {
      var holder = btns[j].parentNode;
      var msg = holder.querySelector('.int-rg-checkout-msg');
      if (blocked && !msg) {
        msg = document.createElement('p'); msg.className = 'int-rg-checkout-msg'; msg.setAttribute('role', 'status'); msg.textContent = MSG_CHECKOUT;
        holder.insertBefore(msg, btns[j]);
      } else if (!blocked && msg) msg.parentNode.removeChild(msg);
    }
  }
  function checkCart(cart) {
    var p = cart ? Promise.resolve(cart)
      : (oFetch ? oFetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }) : Promise.resolve(null));
    p.then(function (c) {
      if (!c || !c.items) return;
      var ids = c.items.map(function (it) { return String(it.variant_id); });
      if (!ids.length) { cartBad = []; markCart(); return; }
      blockedOf(ids).then(function (bad) {
        /* the server list is kept when the worker cannot be reached */
        var srv = CART_IDS.filter(function (id) { return ids.indexOf(id) > -1; });
        if (set || pageSet()) { cartBad = bad; srv.forEach(function (id) { if (cartBad.indexOf(id) < 0) cartBad.push(id); }); }
        else cartBad = cartBad.filter(function (id) { return ids.indexOf(id) > -1; });
        markCart();
      });
    }).catch(function () {});
  }
  document.addEventListener('theme:cart:change', function (e) {
    var c = e && e.detail && e.detail.cart;
    checkCart(c && c.items ? c : null);
    setTimeout(markCart, 300); setTimeout(markCart, 900);
  });
  document.addEventListener('click', function (e) {
    if (!document.body.classList.contains('int-rg-cart-blocked')) return;
    var t = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"], .int-cart-checkout-button');
    if (t) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  function start() {
    markCart();
    var hasCart = CART_IDS.length || D.count > 0;
    var canAdd = document.querySelector('form[action*="/cart/add"]');
    if (hasCart || canAdd) {
      var go = function () { load().then(function () { if (hasCart) checkCart(); }); };
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 3000 }); else setTimeout(go, 1500);
    } else {
      var first = function () { load(); window.removeEventListener('pointerdown', first, true); window.removeEventListener('keydown', first, true); };
      window.addEventListener('pointerdown', first, true);
      window.addEventListener('keydown', first, true);
    }
    var d = document.getElementById('drawer-cart');
    if (d && window.MutationObserver) {
      var to = null;
      new MutationObserver(function () { clearTimeout(to); to = setTimeout(markCart, 60); }).observe(d, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.__intRegionGuard = { region: R, load: load, check: blockedOf, cart: checkCart };
})();
